import { modalUser } from './user/modals/modal-user';
import { initProfileOrganization } from './user/profile/organization/main';
import { resettingPassword } from './user/profile/resetting-password';

export const user = () => {
  resettingPassword();

  if (
    document.querySelector('header')
    && document.querySelector('.modal-user')
  ) {
    modalUser('.modal-user');
  }

  if (document.getElementById('user-profile-team')) {
    initProfileOrganization();
  }
};
